import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import api from "@/lib/api";
import { SectionHead } from "@/components/Bits";

export default function ProvaSocial() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/showcase").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (items.length === 0) return null;

  const testimonials = items.filter((i) => i.kind === "testimonial");
  const cases = items.filter((i) => i.kind !== "testimonial");

  return (
    <section className="border-t border-[#27272A] bg-[#0A0A0B]">
      <div className="mx-auto max-w-[1400px] px-4 py-20 lg:px-8">
        <SectionHead eyebrow="Prova Social" title="Projetos e clientes" sub="Equipamentos entregues e depoimentos de quem confia na Global Refrigeração." />
        {cases.length > 0 && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {cases.map((c) => (
              <div key={c.id} data-testid={`showcase-case-${c.id}`} className="flex flex-col border border-[#27272A] bg-[#151618]">
                {c.image && <div className="relative aspect-[16/10] overflow-hidden bg-black"><img src={c.image} alt={c.title} className="h-full w-full object-cover" /></div>}
                <div className="p-6">
                  {c.segment && <span className="label-eyebrow text-[#FF5500]">{c.segment}</span>}
                  <h3 className="font-heading mt-2 text-lg font-bold text-white">{c.title}</h3>
                  {c.client && <p className="mt-1 text-sm text-[#A1A1AA]">{c.client}{c.city ? ` — ${c.city}` : ""}</p>}
                  {c.quote && <p className="mt-3 text-sm text-[#A1A1AA]">{c.quote}</p>}
                </div>
              </div>
            ))}
          </div>
        )}
        {testimonials.length > 0 && (
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
            {testimonials.map((t) => (
              <div key={t.id} data-testid={`showcase-testimonial-${t.id}`} className="border border-[#27272A] bg-[#151618] p-8">
                <Quote className="h-7 w-7 text-[#FF5500]" />
                <p className="mt-4 text-white">{t.quote}</p>
                <p className="mt-4 text-sm text-[#A1A1AA]">{t.client}{t.city ? ` — ${t.city}` : ""}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
